// initial state
const state = {
  types: {
    0: 'SKU',
    1: '品牌',
    2: '活动',
  }
}

// getters
const getters = {}

// actions
const actions = {}

// mutations
const mutations = {}

export const clbProduct = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/clb-product/clb-product.store.js